global.CHANNEL_NAMES = {
  'sms' : "СМС",
  "vk": "ВК/ОК",
  // "sms_viber": "Viber",
  "call" : "Звонок",
  "telegram": "Telegram",
  "whatsapp": "Watsapp",
  "viber": "Viber",
  "push": "SIM PUSH"
}

global.CALL_TYPES = {
  "flash" : "Коды в номере",
  "voicePassword" : "Голосовые сообщения",
  "voiceCode" : "Коды голосом",
  "bCall": "Авторизация исходящим"
}

global.CALL_TYPES_BY_INDEX = {
  0: "Коды в номере",
  1: "Голосовые сообщения",
  2: "Коды голосом",
  3: "Авторизация исходящим"
}

global.CALLS_SEGMENTATION_TYPE = {
  0: "Факт звонка",
  1: "Длительность звонка"
}
global.CALLS_SEGMENTATION_UNITS = {
  0: "Секунда",
  1: "Минута"
}

global.TRAFFIC_TYPES = {
  "" : "Мультиподпись",
  "add" : "Рекламный",
  "service" : "Сервисный",
  "informational" : "Информационный",
  "transactional" : "Транзакционный",
  "authorisation" : "Авторизационный",
  "templated_add" : "Рекламный с шаблоном",
  "package": "Пакет",
  "flash" : "Коды в номере",
  "voicePassword" : "Голосовые сообщения",
  "voiceCode" : "Коды голосом",
  "bCall": "Авторизация исходящим",
}

global.RATE_TYPE_NAMES = {
  "0": "Исходящие SMS",
  "1": "Входящие SMS",
  "2": "Прием оплаты через ассист",
  "3": "Прием оплаты банковским переводом",
  "4": "Внутренний перевод",
  "5": "Бонус",
  "6": "Робокасса",
  "7": "ОСМП",
  "8": "Использование овердрафта",
  "9": "Скидка",
  "10": "Штрафы",
  "11": "Банковский перевод",
  "12": "Вознаграждение коммерческому исполнителю",
  "13": "Разовые услуги",
  "14": "Звонки",
  "15": "Ю-мани",
  "20": "SIM PUSH"
}

global.RATE_SUBTYPE_NAMES = {
  0: "Фиксированный для SMS",
  1: "Гибкий для SMS",
  2: "Посендерный",
  3: "Посендерный с шаблонами",
  7: "Профи",
  8: "Международный"
}
global.CALL_RATE_SUBTYPE_NAMES = {
  0: "Фиксированный для звонков",
  1: "Гибкий для звонков"
}
global.SIM_PUSH_RATE_SUBTYPE_NAMES = {
  0: "Фиксированный для SIM PUSH",
  1: "Гибкий для SIM PUSH"
}

global.TEMPLATE_TRAFFIC_TYPES = {
  "no_template" : "Рекламный",
  "service": "Сервисный",
  "informational": "Информационный",
  "transactional": "Транзакционный",
  "authorisation": "Авторизационный",
  "templated_add" : "Рекламный с шаблоном",
}

global.AGREGATOR_STATUS_LIST = {
  '-1': 'Ожидает отправки',
  '1': 'Сообщение отправлено',
  '2': 'Доставлено адресату',
  '3': 'Просрочено',
  '4': 'Удалено',
  '5': 'Не доставлено',
  '6': 'сообщение находится в принятом состоянии (т.е. читалось вручную от имени абонента клиентской службой)',
  '7': 'сообщение находится в недопустимом состоянии',
  '8': 'сообщение находится в отклоненном состоянии'
}

global.AGREGATOR_STATUS_LIST_CALLS = {
  '-1': 'Вызов ожидает очереди',
  '1': 'В процессе вызова',
  '2': 'Вызов осуществлен успешно',
  '__default__': 'Ошибка вызова'
}

global.DOCUMENT_DELIVERY_TYPE_NAMES = {
  'paper': 'На бумажных носителях',
  'edo': 'ЕДО'
}

global.SCHEDULE_TYPES = {
  '-1' : 'Моментальная рассылка',
  '0': "Отложенная рассылка",
  '1': "Отложенная распределенная рассылка",
  '2': "События адресатов",
}

global.verbose_statuses_call = {
  "153": "Вызов заблокирован, номере телефона находится в черном списике",
  "2561": "Превышен лимит звонков 1 абоненту в сутки",
  "220": "Звонок не прошел модерацию",
  "210": "Звонок не прошел модерацию",
  "222": "Звонок не прошел модерацию",
  "221": "Звонок не прошел модерацию",
  "211": "Звонок не прошел модерацию",
  "252": "Звонок не прошел модерацию",
  "253": "Звонок не прошел модерацию",
  "200": "Звонок поставлен в очередь",
  "201": "Звонок поставлен в очередь"
}

global.SENDERS_OPERATOR_CONFIG = {
  mts: {name: "МТС", freeNameAvailable: false},
  megafon: {name: "Мегафон", freeNameAvailable: false, singularRating: true},
  beeline: {name: "Билайн", freeNameAvailable: true},
  tele2: {name: "Теле2", freeNameAvailable: true},
}


global.patchPhone = phone => {
  phone = phone.replace(/\D/g, '')
  if (phone.length === 11 && phone.startsWith("89")) phone = phone.replace("8", "7")
  return phone
}

global.validatePhone = phone => {
  if(phone.startsWith("372") || phone.startsWith("65")) return (phone.length >= 10 && phone.length < 14)
  else return (phone.length > 10 && phone.length < 14)
}

global.escapeRegExp = str => {
  return str.replace(/[.*+?^${}()|[\]\\\-]/g, '\\$&')
}
